import { render, staticRenderFns } from "./hrmsHolidayTypesTable.vue?vue&type=template&id=6e90a782"
import script from "./hrmsHolidayTypesTable.vue?vue&type=script&lang=js"
export * from "./hrmsHolidayTypesTable.vue?vue&type=script&lang=js"
import style0 from "./hrmsHolidayTypesTable.vue?vue&type=style&index=0&id=6e90a782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports